export const kartoyImages = {
  profile: require('./profile.png'),
  cardVirtual: require('@shared-ui/components/app/bank-card/assets/virtual.png'),
  cardInfoVirtual: require('@shared-ui/components/app/bank-card/assets/virtual.png'),
  cardReady: require('@shared-ui/components/app/bank-card/assets/virtual.png'),
  cardTransaction: require('@shared-ui/components/app/bank-card/assets/virtual.png'),
  cardPlatinum: require('@shared-ui/components/app/bank-card/assets/platinum.png'),
  phoneIllustration: require('./phone-illustration.png'),
  tBank: require('./banks/t-bank.png'),
  tBankAvatarLogo: require('./banks/tbank-avatar.png'),
  vtbAvatarLogo: require('./banks/vtb-avatar.png'),
  sber: require('./banks/sber.png'),
  alfa: require('./banks/alfa.png'),
  vtb: require('./banks/vtb.png'),
  yandex: require('./banks/yandex.png'),
  otherBank: require('./banks/other.png'),
  domrf: require('./banks/domrf.png'),
  gazprom: require('./banks/gazprom.png'),
  kgBakai: require('./banks/kg-bakai.png'),
  kgDemir: require('./banks/kg-demir.png'),
  kgKicb: require('./banks/kg-kicb.png'),
  kgMbank: require('./banks/kg-mbank.png'),
  kgOptima: require('./banks/kg-optima.png'),
  mts: require('./banks/mts.png'),
  ozon: require('./banks/ozon.png'),
  post: require('./banks/post.png'),
  raiffeisen: require('./banks/raiffeisen.png'),
  rocket: require('./banks/rocket.png'),
  rshb: require('./banks/rshb.png'),
  sovcom: require('./banks/sovcom.png'),
  spb: require('./banks/spb.png'),
  wb: require('./banks/wb.png'),
} as const

export const kartoyServiceImages = {
  adobe: require('./card-pay-services/adobe.png'),
  airbnb: require('./card-pay-services/airbnb.png'),
  amazon: require('./card-pay-services/amazon.png'),
  booking: require('./card-pay-services/booking.png'),
  chatgpt: require('./card-pay-services/chatgpt.png'),
  claude: require('./card-pay-services/claude.png'),
  ebay: require('./card-pay-services/ebay.png'),
  figma: require('./card-pay-services/figma.png'),
  netflix: require('./card-pay-services/netflix.png'),
  neural3: require('./card-pay-services/neural-3.png'),
  neural4: require('./card-pay-services/neural-4.png'),
  shopee: require('./card-pay-services/shopee.png'),
  spotify: require('./card-pay-services/spotify.png'),
  steam: require('./card-pay-services/steam.png'),
  uber: require('./card-pay-services/uber.png'),
  zoom: require('./card-pay-services/zoom.png'),
} as const

export * from './svg'
